import { getMessagingInstance } from '../firebase';
import { onMessage } from 'firebase/messaging';

class PushNotifications {
  public async initialize() {
    const messagingInstance = await getMessagingInstance();
    
    if (messagingInstance) {
      onMessage(messagingInstance, (payload) => {
        console.log('Message received. ', payload);
        
        // Visa notifikation
        const notificationTitle = payload.notification?.title || 'Ny notis';
        const notificationOptions = {
          body: payload.notification?.body || '',
          icon: payload.notification?.icon || '/assets/icon/favicon.png',
          badge: '/assets/icon/favicon.png',
          tag: payload.data?.tag || 'default',
          requireInteraction: false,
          data: payload.data
        };

        // Kontrollera om vi har tillstånd
        if (Notification.permission === 'granted') {
          try {
            // Visa notifikation via Service Worker om tillgänglig
            if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
              navigator.serviceWorker.ready.then((registration) => {
                registration.showNotification(notificationTitle, notificationOptions);
              });
            } else {
              // Fallback till vanlig Notification API
              new Notification(notificationTitle, notificationOptions);
            }
          } catch (error) {
            console.error('Fel vid visning av notifikation:', error);
          }
        } else {
          console.log('Notifikationer är inte tillåtna');
        }
      });
    } else {
      console.log('Firebase Cloud Messaging är inte tillgängligt');
    }
  }
}

export default new PushNotifications();
